<template>
  <div class="drawer_dialog">
    <el-table
      ref="elTable"
      :data="tableData"
      border
      :height="tableHeight"
      @header-dragend="headerWidthChange"
    >
      <el-table-column :label="$t('operationCenter.ind')" width="60px" align="center">
        <template slot-scope="scope">
          <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in currentColumns"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :align="item.fixed"
        :width="item.width"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div>{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, ind) in getCurrentColumns"
        :key="ind + 100"
        :prop="item.prop"
        :label="item.label"
        :align="item.fixed"
        :width="item.width"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div>{{ scope.row[item.prop] }}</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页工具 -->
    <div class="pagination">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryForm.pageNumber"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="queryForm.pageSize"
        :total="total"
        background
        style="margin: 10px 0"
        @current-change="getExamineTableData"
        @size-change="getExamineTableData"
      />
    </div>
  </div>
</template>

<script>
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { apiSiteExpenseGetPage } from '@/api/finance/receivables';
import { cloneDeep } from 'lodash-es';
import resizeHeight from '@/views/finance/mixins/resizeHeight';

export default {
  name: 'BatchNumberDetail',
  mixins: [resizeHeight],
  props: {
    detailRow: {
      type: Object,
      required: true
    },
    // batchNumber: {
    //   type: String,
    //   default: ''
    // },
    billBatchData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          receiptNumber: '', // 收款单号
          siteId: '', // 业务主体
          name: '' // 网点名称
        }
      },
      total: 0,
      tableData: [],
      currentColumns: [],
      getCurrentColumns: [],
      selectData: [],
      totalFee: 0
    };
  },
  computed: {
    tableHeight() {
      return (this.windowHeight - 134) + 'px';
    },
    columnList() {
      return [
        {
          label: this.$i18n.t('basicData.all'), // '全部',
          prop: '',
          children: [
            // 业务主体
            { prop: 'providerName', label: this.$i18n.t('basicData.BusinessPrincipal'), width: 120, fixed: 'left', highlight: false, disabled: true },
            // 网点
            { prop: 'siteName', label: this.$i18n.t('basicData.Outlets'), width: 120, fixed: 'left', highlight: false, disabled: true },
            // 业务单号
            { prop: 'waybillNumber', label: this.$i18n.t('receivablePayable.TicketNumber'), width: 160, fixed: 'left', highlight: false, disabled: true },
            // 客户单号
            { prop: 'customerNumber', label: this.$i18n.t('receivablePayable.CustomerTrackingNumber'), width: 160, fixed: 'left', highlight: false, disabled: true },
            // 客户
            { prop: 'customerAlias', label: this.$i18n.t('receivablePayable.customer'), width: 160, fixed: 'left', highlight: false, disabled: true },
            // 业务时间
            { prop: 'collectInputTime', label: this.$i18n.t('basicData.BusinessTime'), width: 120, fixed: 'left', highlight: true, disabled: true },
            // 计费重量
            { prop: 'chargeWeight', label: this.$i18n.t('receivablePayable.BillableWeight'), width: 120, fixed: 'left', highlight: true, disabled: true },
            // 应收费用
            { prop: 'totalFee', label: this.$i18n.t('basicData.FeesApply'), width: 120, fixed: 'left', highlight: true, disabled: true },
            // 备注
            { prop: 'remark', label: this.$i18n.t('basicData.remark'), width: 160, fixed: 'left', highlight: false, disabled: true }
          ]
        }
      ];
    }
  },
  created() {
    this.createUser = getUserIdAndNameObj();
    this.currentColumns = this.columnList[0].children;
    this.tableKey = new Date().getTime();
    this.queryForm.params.receiptNumber = this.detailRow.batchNumber;
    this.queryForm.params.siteId = this.detailRow.siteId;
    this.queryForm.params.name = this.detailRow.name;
    this.getExamineTableData();
  },
  methods: {
    // 表头宽度变化
    headerWidthChange() {
      this.$nextTick(() => {
        this.$refs.elTable.doLayout();
      });
    },
    // 获取列表
    getExamineTableData() {
      const param = cloneDeep(this.queryForm);
      this.getCurrentColumns = [];
      // 获取列表数据
      apiSiteExpenseGetPage(param).then(resp => {
        if (resp.code === 200) {
          this.tableData = resp.data;
          this.total = resp.total;
          if (resp.data.length > 0) {
            this.getCurrentColumns = [];
            resp.columns.map(item => {
              const obj = {
                prop: item.prop,
                label: item.label.split('_')[0],
                width: 200,
                fixed: 'left',
                highlight: false
              };
              this.getCurrentColumns.push(obj);
              this.$nextTick(() => {
                this.$refs.elTable.doLayout();
                this.rowSelectFlag = true;
                this.tableData.map(list => {
                  const matchedIndex = this.selectData.findIndex(itemList => itemList.id === list.id);
                  this.$refs.elTable.toggleRowSelection(list, matchedIndex !== -1);
                });
                this.rowSelectFlag = false;
              });
            });
          }
        }
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
.drawer_dialog {
  height: 100%;
}
</style>
